import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-checklist-view',
  template: `
  <nz-tabset>
    <nz-tab nzTitle="Loading Checklist">
        <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
            <div class="flex items-center gap-3 mb-4">
                <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                    <i nz-icon nzType="up-circle" nzTheme="outline" class="text-white text-lg"></i>
                </div>
                <div>
                    <h4 class="text-lg font-semibold text-gray-800">Loading Checklist</h4>
                    <p class="text-sm text-gray-600">Documents for loading verification</p>
                </div>
            </div>
            <ng-container *ngIf="checklist?.['loading'] as loading">
                <nz-list *ngIf="loading?.files?.length > 0" nzSize="small" class="border rounded-lg bg-white"
                    style="max-height: 300px; overflow-y: auto;">
                    <nz-list-item *ngFor="let file of loading.files">
                        <div class="flex justify-between w-full items-center text-xs px-2 py-0.5">
                            <div class="flex items-center gap-3 min-w-0">
                                <span class="truncate font-medium text-gray-700" [title]="file?.originalName">
                                    {{ file?.originalName || 'Unnamed file' }}
                                </span>
                            </div>
                            <div class="flex gap-2">
                                <a *ngIf="file?.url" [href]="file.url" target="_blank" download="{{file?.originalName}}"
                                    class="flex items-center justify-center w-8 h-8 rounded hover:bg-blue-100 text-blue-600 hover:text-blue-800 transition-all duration-150"
                                    title="Download">
                                    <i nz-icon nzType="download" nzTheme="outline" class="text-lg"></i>
                                </a>
                            </div>
                        </div>
                    </nz-list-item>
                </nz-list>
            </ng-container>
            <ng-container *ngIf="!checklist['loading']?.files?.length">
                <div class="flex flex-col items-center justify-center py-6">
                    <i nz-icon nzType="inbox" nzTheme="outline" class="text-3xl text-gray-300 mb-2"></i>
                    <p class="text-gray-400 text-sm italic">No files uploaded yet.</p>
                </div>
            </ng-container>
        </div>
    </nz-tab>
    <nz-tab nzTitle="Unloading Checklist">
        <div class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100">
            <div class="flex items-center gap-3 mb-4">
                <div class="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
                    <i nz-icon nzType="down-circle" nzTheme="outline" class="text-white text-lg"></i>
                </div>
                <div>
                    <h4 class="text-lg font-semibold text-gray-800">Unloading Checklist</h4>
                    <p class="text-sm text-gray-600">Documents for unloading verification</p>
                </div>
            </div>
            <ng-container *ngIf="checklist['unloading'] as unloading">
                <nz-list *ngIf="unloading?.files?.length > 0" nzSize="small" class="border rounded-lg bg-white"
                    style="max-height: 300px; overflow-y: auto;">
                    <nz-list-item *ngFor="let file of unloading.files">
                        <div class="flex justify-between w-full items-center text-xs px-2 py-0.5">
                            <div class="flex items-center gap-3 min-w-0">
                                <span class="truncate font-medium text-gray-700" [title]="file?.originalName">
                                    {{ file?.originalName || 'Unnamed file' }}
                                </span>
                            </div>
                            <div class="flex gap-2">
                                <a *ngIf="file?.url" [href]="file.url" target="_blank" download="{{file?.originalName}}"
                                    class="flex items-center justify-center w-8 h-8 rounded hover:bg-blue-100 text-blue-600 hover:text-blue-800 transition-all duration-150"
                                    title="Download">
                                    <i nz-icon nzType="download" nzTheme="outline" class="text-lg"></i>
                                </a>
                            </div>
                        </div>
                    </nz-list-item>
                </nz-list>
            </ng-container>
            <ng-container *ngIf="!checklist['unloading']?.files?.length">
                <div class="flex flex-col items-center justify-center py-6">
                    <i nz-icon nzType="inbox" nzTheme="outline" class="text-3xl text-gray-300 mb-2"></i>
                    <p class="text-gray-400 text-sm italic">No files uploaded yet.</p>
                </div>
            </ng-container>
        </div>
    </nz-tab>
  </nz-tabset>
  `,
})
export class ChecklistViewComponent implements OnChanges  {
  @Input({ required: true }) checklist: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['checklist']) {
      this.checklist = changes['checklist'].currentValue;
    }
  }
}
